import {
  borderRadius,
  breakpoints,
  Modal,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  ${Modal.Styled.ModalContainer} {
    width: 800px;
  }

  ${Modal.Styled.ButtonsContainer} {
    margin-left: 0;
    margin-right: 0;
    padding: 20px 20px 0 20px;
    border-top: 1px solid var(--border-soft);
  }

  @media ${breakpoints['max-sm']} {
    ${Modal.Styled.ModalContainer} {
      width: 80%;
    }
  }
`;

export const Content = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;

export const Sources = styled.div`
  border: 1px solid var(--border-soft);
  ${borderRadius.r2};
`;

export const ResetDescription = styled.p`
  ${typographyV2.bodySm};
`;
